import { c as _c } from "react/compiler-runtime";
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { FTunnelPageBookingTypeEnum } from '@/types/tunnel';
import buildTunnelHref from '@/utils/routes/buildTunnelHref';
import { Button } from '@winelidays/wld-tsx-2/elements';
import { useNavigate } from 'react-router-dom';
const OfferButton = (t0) => {
    const $ = _c(9);
    const { entityId, className: t1 } = t0;
    const incomingClassName = t1 === undefined ? "" : t1;
    const navigate = useNavigate();
    const translate = useTranslate();
    let t2;
    if ($[0] !== translate) {
        t2 = translate("messages.action.offer-book");
        $[0] = translate;
        $[1] = t2;
    }
    else {
        t2 = $[1];
    }
    const title = t2;
    let t3;
    if ($[2] !== entityId || $[3] !== navigate) {
        t3 = () => {
            navigate(buildTunnelHref(FTunnelPageBookingTypeEnum.voucher, entityId));
        };
        $[2] = entityId;
        $[3] = navigate;
        $[4] = t3;
    }
    else {
        t3 = $[4];
    }
    const handleBook = t3;
    const className = `btn btn-outline-primary !py-2 ${incomingClassName}`;
    let t4;
    if ($[5] !== className || $[6] !== handleBook || $[7] !== title) {
        t4 = <Button data-dispo={true} title={title} onClick={handleBook} className={className}>
      {title}
    </Button>;
        $[5] = className;
        $[6] = handleBook;
        $[7] = title;
        $[8] = t4;
    }
    else {
        t4 = $[8];
    }
    return t4;
};
export default OfferButton;
